// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"e75445ad","762":"a61db77a"}[chunkId] + ".chunk.js";
};